module.exports = __webpack_public_path__ + "static/jeff-wells-b92a47335ad9d8898d7d7286bff3d5dc.png";